export const NO_PROJECT_CONTACT_GOOGLE_REVIEW_LABEL = "Add a contact to this project to request a Google review";
